import { VFlow } from 'bold-ui'
import React from 'react'
import { capitalize } from 'util/strConversor'

export type ProcedimentoSelectFieldItemModel = {
  codigo: string
  descricao: string
  procedimentoReferencia?: { id: string; descricao: string; codigo: string }
}

export const ProcedimentoSelectFieldItem = (item: ProcedimentoSelectFieldItemModel) => (
  <VFlow vSpacing={0}>
    <b>{capitalize(item.procedimentoReferencia?.descricao || item.descricao)}</b>
    <>
      <b>Código </b> {item.procedimentoReferencia?.codigo || item.codigo}
    </>
    {item.procedimentoReferencia?.codigo && (
      <>
        <b>CDS </b> {capitalize(item.descricao)}
      </>
    )}
  </VFlow>
)
